module.exports = __webpack_public_path__ + "bee3b2d5585f70bf8de8cdce879da24c.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/fs.svg
// module id = 962
// module chunks = 0